// const ApexCharts = require('apexcharts');
import Api from './Api';
import { createApp } from './components/HeaderBar.mjs';

export default async function run() {
    createApp('header.navbar');
}
